import React from 'react';
import { Icon } from '@app/src/common/Icon';
import { Wrapper, Text } from './styled';
import { getItemNav } from '@app/src/utils/categories';

interface Props {
  itemActive: string;
}

export const UbicationSite: React.FC<Props> = ({itemActive}) => {

  const [ item ] = getItemNav(itemActive);

  return (
    <Wrapper>
      <Icon data-name={item && item.icon} width="32" height="32" fill={item && item.color || '#000'} />
      <Text color={item && item.color}>{item && item.text}</Text>
    </Wrapper>
  )
};
